<div class="profile-page bg-secondary">
  <main class="pt-4">
    <div class="container wow fadeIn">
      <legend>Approved</legend>
      <!--Grid row-->
      <div class="row">
        <div class="table-responsive">
          <b-table striped hover :items="items" :fields="fields">
            <template #cell(createdOn)="data">
              <span>{{data.item.createdOn | formateDate}}</span>
            </template>
            <template #cell(capturedBy)="data">
              <b-badge v-if="data.item.capturedBy === 'SmsRelay'" variant="success">SMS Relay</b-badge>
              <span v-else-if="data.item.capturedBy">{{ data.item.capturedBy }}</span>
              <span v-else class="text-muted">&mdash;</span>
            </template>
            <template #cell(approvedBy)="data">
              <b-badge v-if="data.item.approvedBy === 'SmsRelay'" variant="success">SMS Relay</b-badge>
              <span v-else-if="data.item.approvedBy">{{ data.item.approvedBy }}</span>
              <span v-else class="text-muted">&mdash;</span>
            </template>
          </b-table>
        </div>
      </div>
      <!--Grid row-->
    </div>
  </main>
  <!--Main layout-->
</div>